import React, { useEffect, useState } from 'react'
import {
	Flex,
	Heading,
	Image,
	Text,
	Box,
	Circle,
	useDisclosure,
	chakra,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalCloseButton,
	useToast,
} from '@chakra-ui/react'
import { loadAwsFile } from './../../utils/aws.util'
import { useOrganizationContext } from './../../context/organization.context'
import ButtonCTA from './../globalComponents/button/index'
import SVGIcon from '../../assets/svgIcons'

export default function OrganizationCard({ cardInfo, onSelect }) {
	const { isOpen, onOpen, onClose } = useDisclosure()
	const toast = useToast()
	const [orgImage, setOrgImage] = useState(null)
	const {
		state: { orgsColor },
	} = useOrganizationContext()

	useEffect(() => {
		let image = null
		if (!!cardInfo?.organization_image_path) {
			loadAwsFile(cardInfo.organization_image_path, d => {
				image = 'data:' + d.type + ';base64,' + d.data
				setOrgImage(image)
			})
		}
	}, [cardInfo?.organization_image_path])

	const openModal = () => {
		if (Number(cardInfo.asset_type_category_id) === 45) {
			toast({
				title: 'Access denied.',
				description: 'Please contact Admin',
				status: 'error',
				duration: 3000,
				isClosable: true,
				variant: 'subtle',
				position: 'top',
			})
		} else onOpen()
	}

	return (
		<>
			<Modal isOpen={isOpen} onClose={onClose} isCentered size='lg'>
				<ModalOverlay />
				<ModalContent
					pl='4.6rem'
					pr='4.6rem'
					pt='5.125rem'
					pb='5.125rem'
					borderRadius='20px'
				>
					<ModalHeader textAlign='left' fontWeight='400' fontSize='1.5rem'>
						Are you sure you want to continue with {cardInfo.organization_name}?
					</ModalHeader>
					<ModalCloseButton m={2} />

					<ModalFooter
						justifyContent='center'
						gap='0.8125rem'
						fontWeight='900'
						fontSize='0.875rem'
						pb={0}
					>
						<ButtonCTA
							bg='white'
							border='2px solid #009B76'
							borderRadius='18px'
							h='2.25rem'
							onClick={onClose}
							color='brand.700'
						>
							NO
						</ButtonCTA>
						<ButtonCTA
							bg='linear-gradient(225deg, #009B76 0%, #0F7A5E 100%, #24A490 100%)'
							borderRadius='18px'
							color='white'
							h='2.25rem'
							onClick={() => onSelect(cardInfo)}
						>
							YES
						</ButtonCTA>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<Flex
				minW='15.625rem'
				h='25rem'
				bg={orgsColor?.[cardInfo.organization_id]}
				color='white'
				flexDirection='column'
				alignItems='center'
				justifyContent='space-evenly'
				m='1.56rem'
				boxShadow='0px 2px 4px rgba(0, 0, 0, 0.25)'
				borderRadius='10px'
				cursor='pointer'
				onClick={openModal}
				_first={{ marginLeft: 'auto' }}
				_last={{ marginRight: 'auto' }}
			>
				{!!orgImage ? (
					<Image
						src={orgImage}
						maxW='10rem'
						maxH='10rem'
						filter='brightness(0) invert(1)'
					/>
				) : (
					<SVGIcon
						iconName='OrgCardGreneLogoSvg'
						svgProps={{
							width: '64',
							height: '60',
							viewBox: '0 0 64 60',
						}}
						// pathProps={{ fill: '#009B76' }}
					/>
				)}
				<Box textAlign='center'>
					<Heading
						fontWeight='900'
						fontSize='1.125rem'
						lineHeight='1.56rem'
						as='h3'
					>
						{cardInfo.organization_name}
					</Heading>
					<Text color='white' opacity='0.8'>
						{cardInfo.asset_type_name}
					</Text>
				</Box>
				{/* <Box>
					<Box display='inline-block' pr={2}>
						<Circle
							fontWeight='900'
							fontSize='1.125rem'
							bg='yellow.600'
							color='black'
							size='1.875rem'
						>
							43
						</Circle>
					</Box>
					<chakra.span opacity='0.8'>Notifications</chakra.span>
				</Box> */}
			</Flex>
		</>
	)
}
